import React from 'react';
import PropTypes from 'prop-types';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import reducer from './reducer';
import saga from './saga';
import { makeSelectOption } from './selectors';
import { updateOption } from './actions';

import './styles.scss';

export class Select extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  handleChange = event => {
    const value = event.target.value;
    this.props.updateValue(value);
    if( typeof this.props.onChange === 'function')
      this.props.onChange();
  };

  render() {
    const { options, value, selectedRange, id, label } = this.props;
    return (
      <div className="element-actions">
        <div className="form-inline justify-content-sm-end">
          <label htmlFor={id} className="sr-only sr-only-focusable">
            {label}
          </label>
          <small className="text-muted pr-3">{selectedRange}</small>
          <select
            className="form-control form-control-sm rounded bright"
            onChange={this.handleChange}
            value={value}
            id={id}
          >
            {options.map((item, key) => (
              <option value={item.value} key={key}>
                {item.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

Select.defaultProps = {
  options: [
    { label: 'Oggi', value: 'today' },
    { label: '7 giorni', value: 'days' },
    { label: 'Questo mese', value: 'month' },
    { label: 'Mese precedente', value: 'prevmonth' },
    { label: 'Quest\'anno', value: 'year' },
    { label: 'Anno precedente', value: 'prevyear' },
  ],
  selectedRange: ''
};

Select.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  selectedRange: PropTypes.string,
};

export function mapDispatchToProps(dispatch) {
  return {
    updateValue: value => dispatch(updateOption(value)),
  };
}

const mapStateToProps = createStructuredSelector({
  value: makeSelectOption(),
});

const withReducer = injectReducer({ key: 'select', reducer });
const withSaga = injectSaga({ key: 'select', saga });
const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Select);

